export default __webpack_public_path__ + "static/media/Markers_Red Marker - Boat.7d16696f.svg";